/**
 * Created by neo on 25.02.17.
 */
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import FlightOffer from '../../Store/FlightOffer';
import { Container, Row, Col, Button } from 'reactstrap';
import FlightOfferStore from '../../Store/FlightOffer/Store';
import FlightRoute from './FlightRoute';
import Booking from './Booking';
import BookingRequest from '../../Store/Booking/BookingRequest';
import MobileBooking from './Booking/Mobile';
import LanguageStore from '../../../lang';
import DisplayToggle from '../../Components/DisplayToggle';
import GalleryHeader from '../../Components/GalleryHeader';

type Props = {
  params: any,
};

@observer
export class FlightOfferViewScreen extends React.Component<Props, void> {
  @observable flightOffer: FlightOffer = new FlightOffer();
  @observable loading: boolean = true;
  @observable booking: BookingRequest;
  @observable showMobileBooking: boolean = false;

  constructor(props: Props) {
    super(props);
    this.booking = new BookingRequest({ flightOffer: this.flightOffer });
  }

  componentWillMount() {
    if (this.props.params.flightOfferId) {
      FlightOfferStore.get(this.props.params.flightOfferId, LanguageStore.lang).then(
        (flightOffer: FlightOffer) => {
          this.flightOffer = flightOffer;
          this.booking = new BookingRequest({ flightOffer });
          if (this.booking.aircraft.price_passenger) {
            this.booking.setPassengerCount(this.props.location.query.passengers || 1);
          } else {
            this.booking.setPassengerCount(this.booking.maxPassengers);
          }

          if (this.props.location.query.aircraft) {
            this.booking.aircraft = this.flightOffer.aircraft_offers.find(a => a.id === +this.props.location.query.aircraft);
          }

          if (this.props.location.query.giftcode) {
            this.booking.voucher.code = this.props.location.query.giftcode;
            this.booking.applyDiscounts();
          }

          this.loading = false;
        },
      );
    }
  }

  handleBooking = (bookingRequest: BookingRequest) => {
    const { is_exclusive, start_time, aircraft, voucher } = bookingRequest;
    const passengerCount = is_exclusive ? bookingRequest.maxPassengers : bookingRequest.passengerCount;
    let params = `aircraft=${aircraft.id}&exclusive=${is_exclusive}&passengers=${passengerCount}&start_time=${start_time}`;

    if (voucher.code) {
      params += `&giftcode=${voucher.code}`;
    }

    this.props.router.push(`/booking/flightoffer/${this.flightOffer.id}?${params}`);
  };

  handleMobileBooking = () => {
    this.showMobileBooking = true;
  };

  handleCloseMobileBooking = () => {
    this.showMobileBooking = false;
  };

  render() {
    const { props: { t }, flightOffer, booking, showMobileBooking } = this;
    return (
      <div>
        <GalleryHeader
          title={`${flightOffer.title}`}
          subtitle={`${flightOffer.time_flight} min`}
          medias={flightOffer.files}
          location={flightOffer.location}
        />
        <Container style={{paddingTop: 50}}>
          <Row>
            <Col xs={12} md="7" lg="8" style={{padding:30}}>
              {
                flightOffer.is_transfer &&
                <Row>
                  <Col xs={12} md={6}>
                    <h4>{t('Pick-up location')}</h4>
                    {flightOffer.location.name}
                  </Col>
                  <Col xs={12} md={6}>
                    <h4>{t('Drop-off location')}</h4>
                    {flightOffer.dropoff_location.name}
                  </Col>
                  <Col xs={12}>
                    &nbsp;
                  </Col>
                </Row>
              }
              {
                flightOffer.description &&
                <Row>
                  <Col>
                    <h2>{t('Description')}</h2>
                    <p className="lead" style={{whiteSpace: 'pre-line'}}>
                      {flightOffer.description}
                    </p>
                  </Col>
                </Row>
              }
              <Row className='mb-3'>
                <Col>
                  <h2>{t('Flugroute')}</h2>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FlightRoute flightOffer={flightOffer} />
                </Col>
              </Row>
            </Col>
            <Col md="5" lg="4" className="booking-side">
              <Booking flightOffer={flightOffer} booking={booking} onBook={this.handleBooking} />
            </Col>
          </Row>
          <DisplayToggle show={showMobileBooking}>
            <MobileBooking
              flightOffer={flightOffer}
              booking={booking}
              onBook={this.handleBooking}
              onClose={this.handleCloseMobileBooking}
            />
          </DisplayToggle>
          <div className="large booking-button">
            <Button color="primary" block onClick={this.handleMobileBooking}>
              {t('Buchen')}
            </Button>
          </div>
        </Container>
      </div>
    );
  }
}

export default translate ()(FlightOfferViewScreen);



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/index.js